import React, { useCallback, useEffect, useRef } from "react"
import useRefValues from "../../hooks/useRefValues"
import styles from "./TelephonyFrame.module.scss"
import { telephonyDomEvent, TelephonyIframeMessage, telephonyNotificationTypes } from "../../models/Telephony/telephony"
import { selectProjectSettings } from "../../store/projects/selectors"
import { useAppSelector } from "../../store/hooks"
import { isUrlValid } from "./helpers"
import { selectCurrentUser } from "../../store/users/selectors"

const TelephonyFrame = () => {
    const telephony = useRefValues("useTelephonyUrl") ?? []
    const settings = useAppSelector(selectProjectSettings)
    const primaryColor = settings?.System?.ColorSchema?.ColorSchemaBaseColor
    const url = telephony.length > 0 ? telephony[0] : ""
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const user = useAppSelector(selectCurrentUser)
    const operatorLogin = user ? user.Login : ""

    const processIframeMessage = useCallback(
        (event: MessageEvent<TelephonyIframeMessage>) => {
            const data = event.data
            if (data.notificationType === telephonyNotificationTypes.ready) {
                const message = {
                    notificationType: telephonyNotificationTypes.initialData,
                    message: {
                        primaryColor: primaryColor ?? "",
                        operatorLogin: operatorLogin
                    }
                }
                sendMessage(message)
            }
        },
        [primaryColor, operatorLogin]
    )

    const processDomEvent = (event: CustomEvent) => {
        const data = event.detail
        console.log("[JS-Agent-bridge] Post message to iframe", data)
        sendMessage(data)
    }

    const sendMessage = (message: TelephonyIframeMessage) => {
        if (iframeRef && iframeRef.current) {
            iframeRef.current.contentWindow?.postMessage(message, "*")
        }
    }

    useEffect(() => {
        window.addEventListener("message", processIframeMessage)
        //тестовый проброс типов, мб ts плка не поддерживает CustomEvent
        document.addEventListener(telephonyDomEvent, processDomEvent as EventListener)
        return () => {
            window.removeEventListener("message", processIframeMessage)
        }
    }, [processIframeMessage])

    if (!url.length || !isUrlValid(url)) {
        return null
    }

    return (
        <div className={styles.container}>
            <iframe className={styles.container_frame} ref={iframeRef} src={url} />
        </div>
    )
}

export default TelephonyFrame
